import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react';
import { SESSION_ENDED_EVENT, SESSION_ENDED_HOLD_KEY } from '@/sessionEndedEvents';

export { SESSION_ENDED_EVENT } from '@/sessionEndedEvents';
export { fireSessionEndedUI } from '@/sessionEndedEvents';

const SessionEndedContext = createContext(null);

export function SessionEndedProvider({ children }) {
    const [sessionEnded, setSessionEnded] = useState(() => {
        if (typeof window === 'undefined') return false;
        try {
            return localStorage.getItem(SESSION_ENDED_HOLD_KEY) === '1';
        } catch {
            return false;
        }
    });
    const [sessionEndedReason, setSessionEndedReason] = useState(null);

    useEffect(() => {
        const onEnded = (e) => {
            setSessionEndedReason(e.detail && Object.keys(e.detail).length > 0 ? e.detail : null);
            setSessionEnded(true);
        };
        window.addEventListener(SESSION_ENDED_EVENT, onEnded);
        return () => window.removeEventListener(SESSION_ENDED_EVENT, onEnded);
    }, []);

    const resetSessionEnded = useCallback(() => {
        setSessionEnded(false);
        setSessionEndedReason(null);
    }, []);

    const value = useMemo(
        () => ({ sessionEnded, sessionEndedReason, resetSessionEnded }),
        [sessionEnded, sessionEndedReason, resetSessionEnded]
    );

    return (
        <SessionEndedContext.Provider value={value}>
            {children}
        </SessionEndedContext.Provider>
    );
}

export function useSessionEnded() {
    const ctx = useContext(SessionEndedContext);
    if (!ctx) {
        throw new Error('useSessionEnded must be used within SessionEndedProvider');
    }
    return ctx;
}
